import React from "react";
import { makeStyles } from 'tss-react/mui';
import { SiteMobileHeader } from "./MobileHeader";
import { SiteDesktopHeader } from "./DesktopHeader";

const useStyles = makeStyles({name: "AppHeader"})(theme => ({
	mobileHeader: {
		display: 'none',
		[theme.breakpoints.down(680)]: {
			display: 'block'
		}
	},
	desktopHeader: {
		display: 'none',
		[theme.breakpoints.up(680)]: {
			display: 'block'
		}
	},
}));

export function SiteHeader() {
	const { classes, cx } = useStyles();
	return (
		<>
			<header>
				<div className={classes.mobileHeader}>
					<SiteMobileHeader />
				</div>
				<div className={classes.desktopHeader}>
					<SiteDesktopHeader />
				</div>
			</header>
		</>
	);
}
